import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { ContactForm } from "~/components/ContactForm/ContactForm"
import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"
import { ContentBlueForm } from "./components/ContentBlueForm/ContentBlueForm"

const StockholdersMeeting: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={t("page.stockholders-meeting")}>
      <div className="container">
        <Breadcrumbs />
        <Content />
      </div>

      <ContactForm
        content={() => <ContentBlueForm />}
        title={t("stockholders-meeting.BlueForm.Title")}
        showMobileText
      />
    </Layout>
  )
}

export default StockholdersMeeting
